export const timelineRandomVisualEffectService = {
  getRandomFullWidthPosition(): number {
    const minLeftPosition = 0;
    const maxLeftPosition = window.innerWidth - 32;

    return Math.round(Math.random() * (maxLeftPosition - minLeftPosition)) + minLeftPosition;
  },

  getRandomLeftPosition(leftHalfOfScreen: boolean): number {
    let minLeftPosition = 0;
    let maxLeftPosition = window.innerWidth - 32;

    if (leftHalfOfScreen) {
      maxLeftPosition = maxLeftPosition / 2;
    } else {
      minLeftPosition = maxLeftPosition / 2;
    }

    return Math.round(Math.random() * (maxLeftPosition - minLeftPosition)) + minLeftPosition;
  },

  getRandomTopPosition(minTopPos?: number, maxTopPos?: number): number {
    const minTopPosition = minTopPos ?? 50;
    const maxTopPosition = window.innerHeight - (maxTopPos ?? 50);

    return Math.round(Math.random() * (maxTopPosition - minTopPosition)) + minTopPosition;
  },

  getRandomFadePosition(epochId: string | number, minMaxTopPos: number): string {
    const categoryElement = document.getElementById(`epoch-id-${epochId}`);

    if (categoryElement) {
      const categoryTopPosition = window.scrollY + categoryElement.getBoundingClientRect().top;
      const fadePositionTweaker = window.innerHeight / 1.2;

      const randomTop = this.getRandomTopPosition(minMaxTopPos, minMaxTopPos);
      const fadePosition = Math.round(categoryTopPosition + randomTop - fadePositionTweaker);

      return fadePosition.toString();
    }

    return "0";
  }
};

export default timelineRandomVisualEffectService;
